import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Box, Divider, IconButton, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import HorizontalFill from "@entrilia/shared/components/HorizontalFill";
import { useUnsavedReportContext } from "../../contexts/UnsavedReportContext";
import {
  selectCurrentReportName,
  selectHasCurrentReport,
  selectIsNewReport,
  selectReportEditMode,
} from "../../store/selectors/currentReportSelectors";
import BackToReports from "./backToReports/BackToReports";
import ReportNameChanger from "./common/report-name-changer/ReportNameChanger";
import FavoriteReportStar from "./FavoriteReportStar";

const UnsavedReportTitle = () => {
  const reportName = useSelector(selectCurrentReportName);
  return (
    <Stack sx={{ minWidth: 0 }}>
      <Typography variant="h6" noWrap>
        {reportName}
      </Typography>
      <Typography variant="caption" color="textSecondary">
        Changes are not saved
      </Typography>
    </Stack>
  );
};

interface Props {
  ReportSelector?: React.ReactElement;
  ProductName?: React.ReactElement;
  readonlyMode?: boolean;
}

export default function ReportActionHeader({
  ReportSelector,
  children,
  ProductName,
  readonlyMode,
}: React.PropsWithChildren<Props>) {
  const unsavedReport = useUnsavedReportContext();
  const isEditMode = useSelector(selectReportEditMode);
  const [isRenaming, setIsRenaming] = useState(false);
  const isNewReport = useSelector(selectIsNewReport);
  const hasReport = useSelector(selectHasCurrentReport);

  return (
    <Box
      sx={(t) => ({
        display: "flex",
        px: 3,
        py: 1.25,
        alignItems: "center",
        gap: 2,
        maxHeight: t.spacing(7.5),
      })}
    >
      {unsavedReport ? (
        <UnsavedReportTitle />
      ) : (
        <>
          <BackToReports ProductName={ProductName} readonlyMode={readonlyMode} />
          <Divider orientation="vertical" flexItem />
          {!isRenaming && ReportSelector}
          {!isNewReport && isEditMode && hasReport && (
            <ReportNameChanger onRenamingChanged={setIsRenaming} showEditReportName readonlyMode={readonlyMode} />
          )}
          <FavoriteReportStar readonlyMode={readonlyMode} />
        </>
      )}
      <HorizontalFill />
      <Box sx={{ flexGrow: 1 }}></Box>
      {children}
      {unsavedReport && (
        <IconButton onClick={unsavedReport.onClose}>
          <CloseRoundedIcon />
        </IconButton>
      )}
    </Box>
  );
}
